import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './AppRouter';
import './index.css';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-2327" data-mp="219oagcpss419">
    <AppRouter data-id="element-2328" data-mp="21961qgly7xcg" />
  </React.StrictMode>);